/**
 * Hero auto-gift pairing + pipeline reconcile (via sc-cart-queue).
 * Merges DOM-seeded pairings, window.SC_FREE_GIFT_PAIRINGS, and sc_free_gift_map.
 */
(function () {
  if (window.__SC_FREE_GIFT_SYNC_INIT__) return;
  window.__SC_FREE_GIFT_SYNC_INIT__ = true;

  var FREE_GIFT_MAP_KEY = 'sc_free_gift_map';
  var GIFT_PROPS = { _seedcube_upsell: 'free_gift' };

  // One-time global purge of stale hero auto-gift pairings.
  // During a sale, product pages wrote hero->free-gift pairings into each
  // visitor's localStorage. Those persist and keep injecting the free gift
  // after the upsell is removed, until the customer revisits that exact PDP.
  // Bumping FREE_GIFT_MAP_VERSION force-clears every customer's stored map once
  // (on their next page load); current pairings then re-seed from the DOM.
  var FREE_GIFT_MAP_VERSION_KEY = 'sc_free_gift_map_v';
  var FREE_GIFT_MAP_VERSION = '2026-07-purge';
  try {
    if (localStorage.getItem(FREE_GIFT_MAP_VERSION_KEY) !== FREE_GIFT_MAP_VERSION) {
      localStorage.removeItem(FREE_GIFT_MAP_KEY);
      localStorage.setItem(FREE_GIFT_MAP_VERSION_KEY, FREE_GIFT_MAP_VERSION);
    }
  } catch (e) {}

  function loadFreeGiftMap() {
    try {
      var raw = localStorage.getItem(FREE_GIFT_MAP_KEY);
      var parsed = raw ? JSON.parse(raw) : {};
      if (!parsed || typeof parsed !== 'object') return {};
      var migrated = {};
      for (var k in parsed) {
        var v = parsed[k];
        migrated[k] = Array.isArray(v) ? v.slice() : (typeof v === 'number' ? [v] : []);
      }
      return migrated;
    } catch (e) {
      return {};
    }
  }

  function saveFreeGiftMap(map) {
    try {
      localStorage.setItem(FREE_GIFT_MAP_KEY, JSON.stringify(map));
    } catch (e) {}
  }

  function parseIdList(raw) {
    return (raw || '')
      .split(',')
      .map(function (s) { return parseInt(s, 10); })
      .filter(Boolean);
  }

  function recordPairings(heroIds, giftIds) {
    if (!heroIds.length || !giftIds.length) return false;
    var map = loadFreeGiftMap();
    var changed = false;

    heroIds.forEach(function (heroId) {
      var key = String(heroId);
      if (!map[key]) map[key] = [];
      giftIds.forEach(function (giftId) {
        if (map[key].indexOf(giftId) === -1) {
          map[key].push(giftId);
          changed = true;
        }
      });
    });

    if (changed) saveFreeGiftMap(map);
    return changed;
  }

  function mergeGlobalPairings() {
    var global = window.SC_FREE_GIFT_PAIRINGS;
    if (!global || typeof global !== 'object') return;

    var changed = false;
    var map = loadFreeGiftMap();

    for (var heroIdStr in global) {
      if (!Object.prototype.hasOwnProperty.call(global, heroIdStr)) continue;
      var giftIds = global[heroIdStr];
      if (!Array.isArray(giftIds)) continue;
      if (!map[heroIdStr]) map[heroIdStr] = [];
      giftIds.forEach(function (giftId) {
        var id = parseInt(giftId, 10);
        if (!id) return;
        if (map[heroIdStr].indexOf(id) === -1) {
          map[heroIdStr].push(id);
          changed = true;
        }
      });
    }

    if (changed) saveFreeGiftMap(map);
  }

  function seedPairingsFromNode(node) {
    if (!node || !node.getAttribute) return false;
    var giftIds = parseIdList(node.getAttribute('data-sc-free-gift'));
    var heroIds = parseIdList(node.getAttribute('data-sc-hero-variants'));
    if (!giftIds.length || !heroIds.length) return false;
    return recordPairings(heroIds, giftIds);
  }

  function seedPairingsFromDOM() {
    var changed = false;
    document.querySelectorAll('[data-sc-free-gift][data-sc-hero-variants]').forEach(function (node) {
      if (seedPairingsFromNode(node)) changed = true;
    });
    mergeGlobalPairings();
    return changed;
  }

  function seedPairingsFromForm(form) {
    if (!form) return;
    if (seedPairingsFromNode(form)) return;

    var host = form.closest('[data-sc-free-gift][data-sc-hero-variants]');
    if (host && seedPairingsFromNode(host)) return;

    var idInput = form.querySelector('[name="id"]');
    var giftHost = form.closest('[data-sc-free-gift]') || document.querySelector('[data-sc-free-gift][data-sc-hero-variants="' + (idInput && idInput.value || '') + '"]');
    if (giftHost) {
      seedPairingsFromNode(giftHost);
      return;
    }

    if (!idInput || !idInput.value) return;

    document.querySelectorAll('[data-sc-free-gift][data-sc-hero-variants]').forEach(function (node) {
      var heroIds = parseIdList(node.getAttribute('data-sc-hero-variants'));
      if (heroIds.indexOf(parseInt(idInput.value, 10)) === -1) return;
      seedPairingsFromNode(node);
    });
  }

  window.SC_seedFreeGiftPairings = seedPairingsFromDOM;

  function getFreeToHeroes() {
    seedPairingsFromDOM();
    var map = loadFreeGiftMap();
    var reverse = {};
    for (var heroIdStr in map) {
      (map[heroIdStr] || []).forEach(function (freeId) {
        if (!reverse[freeId]) reverse[freeId] = [];
        reverse[freeId].push(parseInt(heroIdStr, 10));
      });
    }
    return reverse;
  }

  function isOurFreeGift(item) {
    if (!item || !item.properties) return false;
    if (item.properties._sc_threshold_gift === 'true') return false;
    return item.properties._seedcube_upsell === 'free_gift';
  }

  function heroQtyForGift(freeIdStr, cartItems, freeToHeroes) {
    var maps = {};
    cartItems.forEach(function (item) {
      maps[item.variant_id] = (maps[item.variant_id] || 0) + item.quantity;
    });
    var total = 0;
    (freeToHeroes[freeIdStr] || []).forEach(function (heroId) {
      total += maps[heroId] || 0;
    });
    return total;
  }

  function computeFixes(cartItems, freeToHeroes) {
    var fixes = [];
    var adds = [];
    var seenGiftIds = {};

    cartItems.forEach(function (item) {
      if (!isOurFreeGift(item)) return;
      var freeIdStr = String(item.variant_id);
      if (seenGiftIds[freeIdStr]) return;
      seenGiftIds[freeIdStr] = true;

      var targetQty = freeToHeroes[freeIdStr]
        ? heroQtyForGift(freeIdStr, cartItems, freeToHeroes)
        : 0;
      var currentQty = 0;
      var lineKey = null;

      for (var i = 0; i < cartItems.length; i++) {
        var giftItem = cartItems[i];
        if (giftItem.variant_id !== parseInt(freeIdStr, 10) || !isOurFreeGift(giftItem)) continue;
        currentQty += giftItem.quantity;
        lineKey = giftItem.key;
      }

      if (targetQty === 0 && currentQty > 0 && lineKey) {
        fixes.push({ type: 'change', key: lineKey, quantity: 0 });
      } else if (targetQty > 0 && currentQty > targetQty && lineKey) {
        fixes.push({ type: 'change', key: lineKey, quantity: targetQty });
      } else if (targetQty > 0 && currentQty < targetQty) {
        adds.push({
          id: parseInt(freeIdStr, 10),
          quantity: targetQty - currentQty,
          properties: GIFT_PROPS
        });
      }
    });

    for (var freeIdStr in freeToHeroes) {
      if (seenGiftIds[freeIdStr]) continue;
      var targetQty = heroQtyForGift(freeIdStr, cartItems, freeToHeroes);
      if (targetQty <= 0) continue;
      adds.push({
        id: parseInt(freeIdStr, 10),
        quantity: targetQty,
        properties: GIFT_PROPS
      });
    }

    return { fixes: fixes, adds: adds };
  }

  function giftMutation(url, body) {
    if (!window.SC_executeGiftMutation) return Promise.resolve(null);
    return window.SC_executeGiftMutation(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    });
  }

  function applyFixesViaPipeline(fixes, adds, cart) {
    var chain = Promise.resolve(cart);

    fixes.forEach(function (fix) {
      chain = chain.then(function (c) {
        return giftMutation('/cart/change.js', { id: fix.key, quantity: fix.quantity }).then(function (updated) {
          return updated || c;
        });
      });
    });

    if (adds.length) {
      chain = chain.then(function (c) {
        return giftMutation('/cart/add.js', { items: adds }).then(function (updated) {
          return updated || c;
        });
      });
    }

    return chain;
  }

  window.SC_heroGiftStatePart = function (cart) {
    if (!cart || !cart.items) return 'h:';
    var parts = [];
    cart.items.forEach(function (item) {
      if (!isOurFreeGift(item)) return;
      parts.push(item.variant_id + ':' + (item.quantity || 0));
    });
    return 'h:' + parts.sort().join(',');
  };

  window.SC_desiredHeroGiftStatePart = function (cart) {
    if (!cart || !cart.items) return 'h:';
    seedPairingsFromDOM();
    var freeToHeroes = getFreeToHeroes();
    var parts = [];
    var seen = {};
    for (var freeIdStr in freeToHeroes) {
      var targetQty = heroQtyForGift(freeIdStr, cart.items, freeToHeroes);
      if (targetQty > 0) {
        parts.push(freeIdStr + ':' + targetQty);
        seen[freeIdStr] = true;
      }
    }
    cart.items.forEach(function (item) {
      if (!isOurFreeGift(item)) return;
      var id = String(item.variant_id);
      if (seen[id]) return;
      parts.push(id + ':0');
    });
    return 'h:' + parts.sort().join(',');
  };

  window.SC_reconcileHeroGiftsForCart = function (cart) {
    if (!cart || !cart.items) return Promise.resolve(cart);

    seedPairingsFromDOM();
    var freeToHeroes = getFreeToHeroes();
    var hasGiftLines = cart.items.some(isOurFreeGift);

    if (!Object.keys(freeToHeroes).length && !hasGiftLines) {
      return Promise.resolve(cart);
    }

    var plan = computeFixes(cart.items, freeToHeroes);
    if (!plan.fixes.length && !plan.adds.length) {
      return Promise.resolve(cart);
    }

    return applyFixesViaPipeline(plan.fixes, plan.adds, cart).catch(function (err) {
      console.error('[SC Gift Sync] hero gift pipeline failed', err);
      return cart;
    });
  };

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    seedPairingsFromForm(form);
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sc-bundle-atc], .sc-cgrid-card__atc, .product-card__button, .product-slider__button, .sc-cube-card[data-sc-free-gift]');
    if (!btn) return;
    var host = btn.closest('[data-sc-free-gift][data-sc-hero-variants]') || btn;
    seedPairingsFromNode(host);
    var form = btn.closest('form[action*="/cart/add"]');
    if (form) seedPairingsFromForm(form);
  }, true);

  if (!window.__SC_FREE_GIFT_FETCH_PATCH__) {
    window.__SC_FREE_GIFT_FETCH_PATCH__ = true;
    var origFetch = window.__SC_NATIVE_FETCH__ || window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf('/cart/add') !== -1) {
        try { seedPairingsFromDOM(); } catch (err) {}
      }
      if (window.SC_cartFetch) return window.SC_cartFetch(input, init);
      return origFetch(input, init);
    };
  }

  if (typeof MutationObserver !== 'undefined') {
    var seedTimer = null;
    var observer = new MutationObserver(function () {
      clearTimeout(seedTimer);
      var runSeed = function () { seedPairingsFromDOM(); };
      seedTimer = setTimeout(function () {
        if (window.requestIdleCallback) {
          window.requestIdleCallback(runSeed, { timeout: 400 });
        } else {
          runSeed();
        }
      }, 200);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('ajaxProduct:added', function () {
    seedPairingsFromDOM();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', seedPairingsFromDOM);
  } else {
    seedPairingsFromDOM();
  }
})();
